
export interface SocketData {
    id: string
    data: any
}

export const GAME_STATE_UPDATE_ENUM_ID = 130

export enum ClientMessageSubType {
    GameAction = 1,
    LobbyAction = 2,
    RoomAction = 3,
    MatchmakingAction = 4,
    ChannelAction = 5,
    Noop = 6,
    GeneralAction = 7,
    Echo = 8,
}

export const SESSION_ESTABLISHED_MESSAGE = 'SESSION_ESTABLISHED'

/* https://tools.ietf.org/html/rfc6455 */
export const SOCKET_CLOSE_GOING_AWAY = 1001
export const SOCKET_CLOSE_SERVER_RESTARTING = 1012
export const SOCKET_CLOSE_FROM_ROOM = 4000
export const SOCKET_CLOSE_SESSION_ERROR = 4003
export const SOCKET_CLOSE_NO_SESSION = 4004
export const SOCKET_CLOSE_SESSION_NOT_YET_ESTABLISHED = 4005
export const SOCKET_CLOSE_SESSION_NOT_RESPONDING = 4006
export const SOCKET_CLOSE_KICKED = 4007
export const SOCKET_CLOSE_USER_LOGOUT = 4009
export const SOCKET_CLOSE_ROOM_STATE_SEQUENCE_ERROR = 4010
export const SOCKET_CLOSE_GAME_CLIENT_ERROR = 4012
export const SOCKET_CLOSE_RATE_LIMITED = 4014
export const SOCKET_CLOSE_USER_CHANGED = 4015
export const SOCKET_CLOSE_PING_TIMEOUT = 4016
export const SOCKET_CLOSE_SERVER_TOO_SLOW = 4017
